// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetContainer {
    .budgetElement {
        width: 70%;
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding: 20px 50px;
        background-color: white;

        label {
            font-size: 16px;
            font-weight: 500;
        }

        .form-control {
            box-shadow: none;
        }

        .elements {
            margin: 15px 0px;
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #D5D5D5;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
            color: black !important;
        }

        /* select:focus {
            outline: none;
            border: none;
            box-shadow: none;
        } */

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: black;
        }



        table {
            width: 100%;
            border: 1px solid black;

            tr,
            th,
            td {
                padding: 10px 5px;
                border: 1px solid black;

            }

            thead {
                tr {
                    background: linear-gradient(to Right, #3b409e, #0067ab, #0f79ba, #0098d5);
                    padding: 10px 0px;
                    font-size: 12px;
                    color: white;
                }
            }
        }
    }
}


.tableDesign {
    border: 1px solid #98BDED;

    table {
        width: 100%;
        border-collapse: collapse;
        /* border: 1px solid #AFD1F6 !important; */

        thead {
            tr {
                color: 'white';
                height: '3.5rem';
                /* border: 1px solid #AFD1F6 !important; */

                th {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }

        tbody {
            tr {
                color: 'white';
                height: '3.5rem';
                border: 1px solid #AFD1F6 !important;

                td {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }


    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/WorkOrderManagement/CreateWorkOrder/workorder.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,gDAAgD;QAChD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,uBAAuB;QAC3B;;QAEA;;;;WAIG;;QAEH;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;;;QAIA;YACI,WAAW;YACX,uBAAuB;;YAEvB;;;gBAGI,iBAAiB;gBACjB,uBAAuB;;YAE3B;;YAEA;gBACI;oBACI,yEAAyE;oBACzE,iBAAiB;oBACjB,eAAe;oBACf,YAAY;gBAChB;YACJ;QACJ;IACJ;AACJ;;;AAGA;IACI,yBAAyB;;IAEzB;QACI,WAAW;QACX,yBAAyB;QACzB,0CAA0C;;QAE1C;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,0CAA0C;;gBAE1C;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;QAEA;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,oCAAoC;;gBAEpC;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;;IAGJ;AACJ","sourcesContent":[".budgetContainer {\n    .budgetElement {\n        width: 70%;\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\n        border-radius: 5px;\n        padding: 20px 50px;\n        background-color: white;\n\n        label {\n            font-size: 16px;\n            font-weight: 500;\n        }\n\n        .form-control {\n            box-shadow: none;\n        }\n\n        .elements {\n            margin: 15px 0px;\n        }\n\n\n        textarea,\n        select,\n        input {\n            width: 100%;\n            border: 1px solid #D5D5D5;\n            padding: 5px 10px;\n            font-size: 16px;\n            font-weight: 400;\n            border-radius: 3px;\n            color: black !important;\n        }\n\n        /* select:focus {\n            outline: none;\n            border: none;\n            box-shadow: none;\n        } */\n\n        textarea {\n            height: 12vh;\n        }\n\n        ::placeholder {\n            color: black;\n        }\n\n\n\n        table {\n            width: 100%;\n            border: 1px solid black;\n\n            tr,\n            th,\n            td {\n                padding: 10px 5px;\n                border: 1px solid black;\n\n            }\n\n            thead {\n                tr {\n                    background: linear-gradient(to Right, #3b409e, #0067ab, #0f79ba, #0098d5);\n                    padding: 10px 0px;\n                    font-size: 12px;\n                    color: white;\n                }\n            }\n        }\n    }\n}\n\n\n.tableDesign {\n    border: 1px solid #98BDED;\n\n    table {\n        width: 100%;\n        border-collapse: collapse;\n        /* border: 1px solid #AFD1F6 !important; */\n\n        thead {\n            tr {\n                color: 'white';\n                height: '3.5rem';\n                /* border: 1px solid #AFD1F6 !important; */\n\n                th {\n                    border: 1px solid #AFD1F6 !important;\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                color: 'white';\n                height: '3.5rem';\n                border: 1px solid #AFD1F6 !important;\n\n                td {\n                    border: 1px solid #AFD1F6 !important;\n                }\n            }\n        }\n\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
